import { createSlice } from '@reduxjs/toolkit'
import { CategoriesType, GetCategoriesResponseType } from '../../actions/types'
import {
  createCategory,
  getCategories,
  getCategoryFromCompany,
  getCurrentCategory,
  getPublicCategories,
} from '../../actions/categoriesAction'

export interface ICategories {
  category: GetCategoriesResponseType
  currentCategory: CategoriesType
  error: any
  isLoading: boolean
  errorImage: any
}

const initialState: ICategories = {
  category: {
    category: [],
    totalCount: 0,
  },

  currentCategory: {
    id: 0,
    name: '',
    description: '',
    company: {
      id: 0,
      name: '',
      role: '',
      city: '',
      address: '',
      contactFullName: '',
      contactPhone: '',
      email: '',
      inn: '',
      description: '',
      createdAt: '',
      isBlocked: false,
      employees: [],
      comments: [],
      images: [],
    },
    products: [],
    createdAt: '',
  },
  isLoading: false,
  error: '',
  errorImage: '',
}

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    clearCurrentCategory: (state) => {
      state.currentCategory = initialState.currentCategory
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCategories.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCategories.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.category = action.payload
    })
    builder.addCase(getCategories.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(getPublicCategories.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getPublicCategories.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.category.category = action.payload
    })
    builder.addCase(getPublicCategories.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(getCategoryFromCompany.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCategoryFromCompany.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.category = action.payload
    })
    builder.addCase(getCategoryFromCompany.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(getCurrentCategory.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getCurrentCategory.fulfilled, (state, action) => {
      state.isLoading = false
      state.error = ''
      state.currentCategory = action.payload
    })
    builder.addCase(getCurrentCategory.rejected, (state, action) => {
      state.isLoading = false
      state.error = action.payload
    })
    builder.addCase(createCategory.pending, (state) => {
      state.error = ''
    })
    builder.addCase(createCategory.fulfilled, (state) => {
      state.error = ''
    })
    builder.addCase(createCategory.rejected, (state, action) => {
      state.error = action.payload
    })
  },
})

export const { clearCurrentCategory } = categoriesSlice.actions

export const categoriesReducer = categoriesSlice.reducer
